const check_street_number = function (country_code) {
  if (country_code) {
    const street_number_required = $.ajax({
      url: '/api/v1/street-number-required/' + country_code,
      method: 'GET'
    })

    street_number_required.done(function (required) {
      // console.debug('street_number_required request ok: ' + required)
      $('#pickup_address_street_number').attr('required', required)
    })

    street_number_required.fail(function (_jqXHR, textStatus) {
      // console.debug('street_number_required request failed: ' + textStatus)
      $('#pickup_address_street_number').attr('required', true)

    })
  }
}

const check_postal_code = function (country_code) {
  if (country_code) {
    const postal_code_required = $.ajax({
      url: '/api/v1/postal-code-required/' + country_code,
      method: 'GET'
    })

    postal_code_required.done(function (required) {
      // console.debug('street_number_required request ok: ' + required)
      $('#pickup_address_postal_code').attr('required', required)
    })

    postal_code_required.fail(function (_jqXHR, textStatus) {
      // console.debug('street_number_required request failed: ' + textStatus)
      $('#pickup_address_postal_code').attr('required', true)

    })
  }
}
function get_location(tenant_id) {
  if(tenant_id == null || tenant_id == "") {
    $('#locations-select').attr('hidden', true);
    $('#locations-select').html('<option value="" selected="selected"></option>');
    return;
  }
  // api call
  const locations = $.ajax({
    url: "/api/v1/locations-of/" + tenant_id,
    method: "GET"
  });

  locations.done(function (collection) {
    if (collection.length > 1) {
      $('#locations-select').attr('hidden', false);
      let options = ''
      options += collection.map(function (slc) {
        return "<option value='" + slc.id + "''>" + slc.name + "</option>"
      }).join("");
      $('#locations-select').html(options);
      $('#locations-select').show();

    } else {
      $('#locations-select').attr('hidden', true).attr('display', 'none');
      $('#locations-select').html('<option value="" selected="selected"></option>');
      $(".wizard .next-step").attr("disabled", false);
    }
  });

  locations.fail(function (_jqXHR, textStatus) {
    console.debug("locations request failed: " + textStatus);
  });


}

function get_sublocation(location_id) {
  if(location_id == null || location_id == "") {
    $(`#${second_select_id()}`).attr('hidden', true);
    $(`#${second_select_id()}`).html('<option value="" selected="selected"></option>');
    return;
  }
  // api call
  const sublocations = $.ajax({
    url: "/api/v1/sublocations-of/" + location_id,
    method: "GET"
  });

  sublocations.done(function (collection) {
    if (collection.length > 0) {
      $(`#${second_select_id()}`).attr('hidden', false);
      if(collection[0].description !== '')
        $(`#${second_select_id()}`).attr('required', true);
      var options = ''
      options += collection.map(function (slc) {
        let desc;
        if (slc.hasOwnProperty('name')) {
          desc = slc.name;
        } else {
          desc = slc.description;
        }

        return "<option value='" + slc.id + "''>" + desc + "</option>"
      }).join("");
      $(`#${second_select_id()}`).html(options);

    } else {
      $(`#${second_select_id()}`).attr('required', false);
      $(`#${second_select_id()}`).attr('hidden', true).attr('display', 'none');
      $(`#${second_select_id()}`).html('<option value="" selected="selected"></option>');
      $(".wizard .next-step").attr("disabled", false);
    }
  });

  sublocations.fail(function (_jqXHR, textStatus) {
    console.debug("Sublocations request failed: " + textStatus);
  });


}
const first_select_id = function () {
  if ($('#sublocations-select')[0] === undefined) {
    return 'tenants-select'
  }
  return 'locations-select'
}
const second_select_id = function () {
  if ($('#sublocations-select')[0] === undefined) {
    return 'locations-select'
  }
  return 'sublocations-select'
}

export {
  check_street_number,
  check_postal_code,
  second_select_id,
  first_select_id,
  get_sublocation,
  get_location
};
